module.exports = __webpack_public_path__ + "media/images/page/top/top_bg_03-87012b78888bcb2b5905d27562f3ccfc.png";